export const LOGO_URL =
  "https://customer-assets-v7afamib.emergentagent.net/job_cb1ecb09-4021-4069-83e5-96a7b3d20b8a/artifacts/722a9c7b7dc2c17d_adj_1.png";

export const COMPANY = {
  brand: "AirDroneJet",
  legal: "Proaura S.r.l.s.",
  address: "Via dei Casali Molinario 3, 00189 Roma (RM)",
  piva: "17045531005",
  email: "info@airdronejet.com",
  phone: "800 300 868",
  web: "www.airdronejet.com",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1698752822107-69f8973936e4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxzb2xhciUyMHBhbmVscyUyMHJvb2YlMjBzdW5zZXQlMjBkcm9uZXxlbnwwfHx8fDE3OTIwMTM3MjF8MA&ixlib=rb-4.1.0&q=85",
  about: "https://customer-assets-0z36b82j.emergentagent.net/job_pannelli-puliti/artifacts/f6c624ce4ce6007d_1%20copia.jpg",
};

export const GALLERY = [
  {
    title: "Lavaggio Residenziale in Corso",
    tag: "Drone Jet Spray",
    image:
      "https://customer-assets-0z36b82j.emergentagent.net/job_pannelli-puliti/artifacts/f4549ca9302efb6d_6DE5768E3A232DC233BFB18C97069161%202.webp",
  },
  {
    title: "Getto Nebulizzato ad Alta Precisione",
    tag: "Unità ADJ in Volo",
    image:
      "https://customer-assets-0z36b82j.emergentagent.net/job_pannelli-puliti/artifacts/e948d8e7d476a994_7E1A0F66DCF335C220047B18F499E9D4.webp",
  },
  {
    title: "Pannelli Puliti a Specchio",
    tag: "Risultato Finale",
    image:
      "https://customer-assets-0z36b82j.emergentagent.net/job_pannelli-puliti/artifacts/a0721149627660fd_IMG_0300.webp",
  },
  {
    title: "Unità ADJ-01 e Stazioni di Controllo",
    tag: "La Flotta",
    image:
      "https://customer-assets-0z36b82j.emergentagent.net/job_pannelli-puliti/artifacts/fecb579fe9dfe4d0_2%20copia.jpg",
  },
];

export const IMAGE_FIELD =
  "https://customer-assets-0z36b82j.emergentagent.net/job_pannelli-puliti/artifacts/a7450a7800e71cc2_1.jpg";

export const PRICE_POINTS = [
  [3, 250], [4, 300], [5, 350], [6, 400], [8, 450], [10, 550],
  [13, 650], [15, 750], [18, 850], [20, 1000], [40, 1500], [60, 2400],
];

export function estimateWashPrice(kw) {
  const pts = PRICE_POINTS;
  if (kw <= pts[0][0]) return pts[0][1];
  if (kw >= pts[pts.length - 1][0]) return pts[pts.length - 1][1];
  for (let i = 0; i < pts.length - 1; i++) {
    const [k1, p1] = pts[i];
    const [k2, p2] = pts[i + 1];
    if (kw >= k1 && kw <= k2) {
      const price = p1 + ((p2 - p1) * (kw - k1)) / (k2 - k1);
      return Math.round(price / 5) * 5;
    }
  }
  return pts[pts.length - 1][1];
}

export const PLANS = {
  singolo: { label: "Lavaggio Singolo", short: "Lavaggio Singolo", washes: 1, multiplier: (b) => b },
  annuale: { label: "Piano Annuale · 2 lavaggi", short: "Piano Annuale", washes: 2, multiplier: (b) => Math.round(2 * b * 0.9) },
  biennale: { label: "Contratto 24 Mesi · 4 lavaggi", short: "Contratto 24 Mesi", washes: 4, multiplier: (b) => Math.round(4 * b * 0.8) },
};

export function planPrice(kw, plan) {
  return PLANS[plan].multiplier(estimateWashPrice(kw));
}

export const ANNUAL_PLANS = [
  { kw: 3, tag: "Casa & Piccolo Tetto" },
  { kw: 6, tag: "Il Più Scelto", popular: true },
  { kw: 8, tag: "Grande Impianto" },
];

export const FAQS = [
  {
    q: "Come funziona la pulizia senza salire sul tetto?",
    a: "I nostri droni volano a quota controllata sopra i pannelli ed erogano un getto nebulizzato di acqua osmotizzata pura che rimuove sporco, guano e polveri sottili senza alcun contatto meccanico dannoso.",
  },
  {
    q: "Come pago il servizio?",
    a: "Il pagamento è anticipato rispetto all'intervento e avviene online in modo sicuro con Stripe (carta, Apple Pay, Google Pay): così possiamo offrirti anche la rateizzazione del servizio. In alternativa la modalità è da accordare con noi al momento della conferma della prenotazione: valutiamo insieme, ad esempio bonifico o saldo a lavoro completato.",
  },
  {
    q: "Cosa include il Piano Annuale e il Contratto 24 Mesi?",
    a: "Il Piano Annuale include 2 lavaggi completi nell'arco di 12 mesi con il 10% di risparmio. Il Contratto 24 Mesi include 4 lavaggi in due anni con il 20% di sconto: ci pensiamo noi a ricordarti le scadenze.",
  },
  {
    q: "Come funziona il codice promo?",
    a: "Se hai ricevuto un codice sconto (es. ADJ10), inseriscilo in fase di prenotazione: lo sconto viene applicato subito sul totale del piano scelto.",
  },
  {
    q: "Posso rateizzare il pagamento?",
    a: "Sì: pagando online possiamo rateizzare il costo del servizio, in particolare sui Contratti 24 Mesi. Se preferisci il bonifico bancario o altre forme di pagamento, accordiamoci direttamente al momento della conferma della prenotazione.",
  },
  {
    q: "La data che scelgo in prenotazione è definitiva?",
    a: "No: la data indicata è una preferenza. Ricevuta la tua richiesta, il nostro team verifica la disponibilità e ti invia la conferma ufficiale sempre via email. L'intervento è fissato solo dopo quella conferma.",
  },
  {
    q: "Cosa succede in caso di maltempo il giorno prenotato?",
    a: "In caso di pioggia o vento forte ti ricontattiamo noi per riprogrammare gratuitamente l'intervento alla prima data utile, direttamente dalla tua area riservata.",
  },
];
